import { createSlice } from '@reduxjs/toolkit';

import { TooltipSliceState, OpenAction } from './tooltip.types';
import { TOOLTIP_SLICE_NAME } from '../slicesNames';

const initialState: TooltipSliceState = {
  title: null,
  message: null,
  isMarkdown: false,
  link: { to: null, label: null },
  href: { to: null, label: null },
};

const tooltipSlice = createSlice({
  name: TOOLTIP_SLICE_NAME,
  initialState,
  reducers: {
    open(state, action: OpenAction) {
      const { message = null, title = null, link, href, isMarkdown = false } = action.payload;
      state.title = title;
      state.message = message;
      state.isMarkdown = isMarkdown;
      if (link) {
        state.link = link;
      } else {
        state.link = initialState.link;
      }
      if (href) {
        state.href = href;
      } else {
        state.href = initialState.href;
      }
    },
    close() {
      return initialState;
    },
  },
});

export default tooltipSlice;
